import { render } from "./edit.vue?vue&type=template&id=44787ee1&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=44787ee1&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44787ee1"]])

export default __exports__